import * as React from 'react';
import styled from 'styled-components';
import InputComponent from '../Input.component';
import { StatusColor } from '../../../constants/statusColors.constant';
import { useTranslation } from 'react-i18next';
import { changeFirstLetterToCapital } from '../../../utils/changeFirstLetterToCapital';
import { useModalManager } from '../../../hooks/ModalManager.hook';
import { ColorPickerModal } from './ColorPickerModal';

interface ColorPickerProps {
  value: StatusColor;
  onChangeColor: (color: StatusColor) => void;
  label?: string;
  disabled?: boolean;
  excludedColors?: Array<StatusColor>;
}

export const ColorPicker: React.FC<ColorPickerProps> = ({
  disabled,
  value,
  onChangeColor,
  label,
  excludedColors = [],
}) => {
  const { t, i18n } = useTranslation();

  const { openModal } = useModalManager();

  const openPickerModal = () => {
    openModal(ColorPickerModal, {
      value,
      excludedColors,
      onChangeColor,
    });
  };

  return (
    <InputComponent
      disabled={disabled}
      value={
        value.length && i18n.exists(`statusColor.${value}`)
          ? changeFirstLetterToCapital(t(`statusColor.${value}`))
          : value
      }
      readonly
      onClick={openPickerModal}
      placeholder={t('Choose color')}
      label={label || t('Color')}
      prefix={value.length ? <ColorCube cubeColor={value} /> : undefined}
    />
  );
};

const ColorCube = styled.div<{ cubeColor: StatusColor }>`
  width: 16px;
  height: 16px;
  border-radius: 5px;
  background: ${props => props.cubeColor};
`;
